import { checkRelatedRPSInspections } from "../data/validations";
import { validateSchemaAll } from "../lib/inspxValidationModule";

export const CHECK_RELATED_INSPECTIONS = "CHECK_RELATED_INSPECTIONS";
export const VALIDATE_CURRENT_INSPECTION = "VALIDATE_CURRENT_INSPECTION";
export const VALIDATE_CURRENT_INSPECTION_TAB = "VALIDATE_CURRENT_INSPECTION_TAB";

export const checkRelatedInspections = (force) => (dispatch, getState) => {
	const state = getState();
	const inspection = state.inspection ? state.inspection.current : null;
	if (inspection && !force) {
		return checkRelatedRPSInspections(inspection).then(check => {
			return Promise.resolve(dispatch({
				type: CHECK_RELATED_INSPECTIONS,
				checkRelatedInspectionsResult: check
			}));
		});
	}
	return Promise.resolve(dispatch({
		type: CHECK_RELATED_INSPECTIONS,
		checkRelatedInspectionsResult: true
	}));
};

export const validateCurrentInspection = () => (dispatch, getState) => {
	const state = getState();
	const inspection = state.inspection ? state.inspection.current : null;
	if (inspection) {
		const schema = inspection.type.schema;
		const result = validateSchemaAll(schema, inspection);
		return Promise.resolve(dispatch({
			type: VALIDATE_CURRENT_INSPECTION,
			validationResult: result
		}));
	}
	return Promise.resolve();
};

export const validateCurrentInspectionTab = (tabName) => (dispatch, getState) => {
	const state = getState();
	let inspection = state.inspection ? state.inspection.current : null;
	inspection = inspection || state.inspection.remote.inspection;
	if (inspection) {
		const schema = inspection.type.schema;
		const result = validateSchemaAll(schema, inspection);
		return Promise.resolve(dispatch({
			type: VALIDATE_CURRENT_INSPECTION_TAB,
			validationResult: result,
			tabName: tabName
		}));
	}
	return Promise.resolve();
};